import { render } from "./YouthSelectExchangeExperiences.vue?vue&type=template&id=7385db4d"
const script = {}
script.render = render

export default script